<template>
  <div :key="image" class="store-logo-container">
    <BasicBtErrorBoundary>
      <nuxt-link
        :to="homelink"
        :external="homelinkExternal"
      >
        <nuxt-img
          id="storeInformation"
          :key="image"
          densities="x1"
          :data-storeid="currentStore?.storeId"
          :src="image"
          class="store-logo transition min-h-14"
          :alt="currentStore?.name"
          :title="currentStore?.name"
          :data-storename="currentStore?.name"
          :data-storeFBPixel="currentStore?.fbPixelId"
          provider="cloudflare"
        />
      </nuxt-link>
    </BasicBtErrorBoundary>
  </div>
</template>
<script setup lang="ts">
const appConfig = useAppConfig();
const currentStore = useCurrentStore();
const image = useCurrentStoreLogo();

const homelink = ref<string>(appConfig.homelink);
const homelinkExternal = ref<boolean>(appConfig.homelinkExternal);

watch(
  () => currentStore.value?.id,
  () => {
    const store = currentStore.value;
    if (!appConfig.isAppUser && store) {
      appConfig.homelink = '/' + store.storeLink || '/';
      appConfig.homelinkExternal = true;

      homelink.value = appConfig.homelink;
      homelinkExternal.value = appConfig.homelinkExternal;
    }
  },
  { immediate: true },
);
</script>